import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/creators/{creatorId}/customer' as const;

export type NoodleCustomerApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

export const useNoodleCustomer = (
  params: NoodleCustomerApi['params'] | null,
  config?: UseNoodleSwrConfig<NoodleCustomerApi['response']>,
): SWRResponse<NoodleCustomerApi['response'], ApiError> => {
  const path = params ? buildPath<NoodleCustomerApi>(PATH_TEMPLATE, params) : null;
  return useNoodleSwr(path, { revalidateOnFocus: false, ...config });
};

/**
 * @deprecated: Please use `useNoodleCustomer` wherever a perfectly fresh response is not worth the network time, bandwidth, and compute.
 */
const getNoodleCustomer = async ({
  creatorId,
}: NoodleCustomerApi['params']): Promise<NoodleCustomerApi['response']> => {
  const path = buildPath<NoodleCustomerApi>(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getNoodleCustomer;
